<template>
  <div class="container-fluid text-muted text-center border-top pt-4 pb-4 mt-5">
    <div class="row">
      <div class="col d-flex justify-content-center">
          <ul style="list-style-type:none;" class="footer-list mb-0">
          <li>
            <a target="_blank" href="https://invite.viber.com/?g2=AQAeUtl4JlWnvExzkGEgJWMdZ6sLMMEtwi%2B6UXIsJW9kVHY2dvAqHUQktVgB5dPu">
            <img
              src="../../assets/Images/vibergroup.svg"
              class="img-fluid"
              alt="image"
              style="height:1.5em;"
            />
            Philstocks Viber Community
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.facebook.com/groups/PhilstocksHangout">
            <img
              src="../../assets/Images/fbhangout.svg"
              class="img-fluid"
              alt="image"
              style="height:1.5em;"
            />
            Philstocks Hangout
            </a>
          </li>
        </ul>
      </div>
    </div>
 <div class="row mt-1">
      <div
        class="col d-flex justify-content-center align-items-center"
      >
        © 2022 Philstocks™ All Rights Reserved. Member: Philippine Stock Exchange
        <br />
      
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.footer-list li{
  display: inline-block;
  margin-left: 1em;
  margin-right: 1em;

}
.footer-list li a{
 text-decoration: none;
}
</style>